export default __webpack_public_path__ + "static/media/multi-transaction.3dfc26dc.svg";